module.exports = __webpack_public_path__ + "img/4.94b4b3e2.jpg";